import React from 'react';
import TextField from '@material-ui/core/TextField';
import Dialog from 'material-ui/Dialog';

const styles = {
    modal: {
        borderRadius: '0'
    },
    marginSide: {
        marginLeft: '1em'
    },
    date: {
        marginTop: "0px !important"
    }
};

let background = {
    color: "whitesmoke",
    backgroundColor: "#375139",
}
const VoucherDialog = ({farmerProfile,amount,dialogOpen,onCancel,onAmountChange,onSubmitFundFarmer}) => {
    const actions = [
        <button onClick={() =>
            onCancel()
        } className="uk-button uk-button-default " type="button">Cancel</button>,
        <button onClick={() => onSubmitFundFarmer()} style={styles.marginSide}
                className="uk-button uk-button-primary" type="button">fund</button>
    ];
    return (
        <Dialog
            title={<h3 style={background} className="uk-modal-title">Send Voucher
            to {farmerProfile.name + " " + farmerProfile.surname}</h3>}
            modal={false}
            open={dialogOpen}
            onRequestClose={() => onCancel()}
            actions={actions}
            autoScrollBodyContent={true}>
            <div className="dialogcontainer">
                <div className="orderprice">
                    <TextField
                        id="outlined-adornment-amount"
                        variant="outlined"
                        label="Amount (Rands)"
                        value={amount}
                        onChange={(e) => onAmountChange(e.target.value)}
                    />
                </div>
            </div>
        </Dialog>
    )

}

export default VoucherDialog;


// WEBPACK FOOTER //
// ./src/components/VoucherDialog.js